import { Requester } from './Requester';

export const SubmitOnboardingSurvey = async (orgId: string): Promise<null> => {
    try {
        await Requester<null>({
            path: `organizations/${orgId}/onboarding/submit`,
            method: 'POST'
        });

        return null;
    } catch (e) {
        console.error('Submit org onboarding survey request failed');
        return Promise.reject(e);
    }
};
